import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

/**
 * Represents the state of an entity in Microsoft Graph. By comparing the fields in the database with the fields in the Microsoft Graph API response, this entity can determine whether an entity is in sync with the Microsoft Graph API.
 */
@Entity()
export class MicrosoftState extends MongoEntity {
  static override _class = 'MicrosoftState';
  static override _collectionName = 'microsoft-state';

  @Field(type => String)
  microsoftID: Maybe<string>;

  @Field(type => Date, { default: v => v ?? new Date() })
  createdAt: Maybe<Date>;

  @Field(type => Date)
  createdInEntra: Maybe<Date>;
}
